import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { PKUrl } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import GREQContactLink from 'components/atoms/PKUrl/GREQContactLink';
import { getCurrentRole } from 'features/views/user/selectors';
import { equalOrThreeDashes } from 'utils';
import { joinString } from 'utils/string';

const AuthorizedPersons = ({ contact }) => {
	const { beneficiaries = [], campaign = {}, policy = {}, id } = contact;

	const { policyNo, systemId } = policy;
	const { communicationCode, endDate } = campaign;

	const userRole = useSelector(getCurrentRole);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('contactDetail:authorizedPersons')} />
				<TableContainer>
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>{getLabelMessage('contactDetail:client')}</TableCell>
								<TableCell>{getLabelMessage('contactDetail:birthNumber')}</TableCell>
								<TableCell />
							</TableRow>
						</TableHead>
						<TableBody>
							{isEmpty(beneficiaries) ? (
								<TableHasNoResults />
							) : (
								beneficiaries.map((person, index) => (
									<TableRow key={index}>
										<TableCell>
											<PKUrl.PKPolicy
												partnerId={person.ccdId}
												policyNo={policyNo}
												systemId={systemId}
												communicationCode={communicationCode}
												campaignEndDate={endDate}
												unlock
												muiLink
											>
												{joinString(' ', [person.surname, person.firstname])}
											</PKUrl.PKPolicy>
										</TableCell>
										<TableCell>{equalOrThreeDashes(person.personalNumber)}</TableCell>
										<TableCell>
											<div className="PszpNoticeButton">
												<GREQContactLink
													contactId={id}
													userRole={userRole}
													insuredCcdId={person.ccdId}
													muiLink
												>
													<Button onClick={null} fullWidth>
														{getLabelMessage('detail:asideBarButtonPszpNotice')}
													</Button>
												</GREQContactLink>
											</div>
										</TableCell>
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</Stack>
		</Paper>
	);
};

AuthorizedPersons.propTypes = {
	contact: PropTypes.object,
};

export default AuthorizedPersons;
